
import DefaultTranslation from '../translations/DefaultTranslation';
import ReportsTranslation from '../translations/ReportsTranslation';
import SystemSettingsTranslation from '../translations/SystemSettingsTranslation';
import BackendTranslation from '../translations/BackendTranslation';
import TooltipTranslation from '../translations/TooltipTranslation';


const allTranslations: Record<string, Record<string, string>> = {
    ...DefaultTranslation,
    ...BackendTranslation,
    ...TooltipTranslation,
    ...SystemSettingsTranslation,
    ...ReportsTranslation
};

const FindTranslation = (key: string) => {
    if (allTranslations[key]) {
        return allTranslations[key];
    }
    
    console.warn(`Translation not found: ${key}`);
    return DefaultTranslation.translationNotFound;
}

const TranslationExists = (key: string) => {
    return allTranslations[key] ? true : false;
}


const LanguageHelper = {
    FindTranslation,
    TranslationExists
}


export default LanguageHelper;